/**
 * Where the rail's ← Back goes when there is no page before this one in the tab: the
 * first page of a visit, opened from a review link, a new tab or a bookmark (review
 * #601, Shayna on Worklist assignments: "i need a back button on this page"). Until
 * then the button hid itself there, so a page reached by a link had no Back at all.
 *
 * The page's own default: the same page without its picks (a worklist, a facility, a
 * sort), or, on a page with nothing picked, the Overview. Null on the bare Overview,
 * where there is nowhere further back to go. What says where the reader is rather than
 * what the page shows is not a pick: the filter bar's params (`f.…`, which follow the
 * reader from page to page anyway), an open review thread, and a link's `v`/`x`.
 */
const NOT_A_PICK = (key: string) => key.startsWith('f.') || key === 'comment' || key === 'v' || key === 'x'

export function backFallback(pathname: string, search: string): string | null {
  const picks = [...new URLSearchParams(search).keys()].some((k) => !NOT_A_PICK(k))
  if (picks) return pathname
  return pathname === '/' ? null : '/'
}
